import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { labService } from '../../../services/labService';

export const LAB_QUERY_KEY = ['labs'];

export function useLabsQuery() {
  return useQuery({
    queryKey: LAB_QUERY_KEY,
    queryFn: labService.getLabs,
  });
}

export function useCreateLabMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: labService.createLab,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: LAB_QUERY_KEY }),
  });
}

export function useUpdateLabMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof labService.updateLab>[1] }) =>
      labService.updateLab(id, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: LAB_QUERY_KEY }),
  });
}

export function useDeactivateLabMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => labService.deactivateLab(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: LAB_QUERY_KEY }),
  });
}
